import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "list" }
const _hoisted_2 = {
  key: 1,
  class: "empty_notice_container"
}

import ExposureListItem from '@/components/ExposureListItem.vue';
import { type ExposureLog } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExposureList',
  props: {
    logs: {},
    dish_id: {}
  },
  setup(__props: any) {


const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.logs.length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.logs, (log, index) => {
          return (_openBlock(), _createBlock(ExposureListItem, {
            key: index,
            id: log.id,
            date: log.date,
            anxiety_level: log.anxiety_level,
            taste: log.taste,
            bodys_reaction: log.bodys_reaction,
            additional_notes: log.additional_notes,
            dish_id: _ctx.dish_id
          }, null, 8, ["id", "date", "anxiety_level", "taste", "bodys_reaction", "additional_notes", "dish_id"]))
        }), 128))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("h1", null, "No exposures logged yet", -1)
        ])))
  ]))
}
}

})